import { RowNode } from "ag-grid-community";
import { ProfileRelationshipEnum } from "~/graphql/supergraphEnums";
import { ProfileNameAndId, OwnersAndControllersRowItem } from "../../types";

export const getDescendants = (
  nodes: RowNode<OwnersAndControllersRowItem>[] | null | undefined,
): ProfileNameAndId[] => {
  if (!nodes) return [];

  return nodes.reduce<ProfileNameAndId[]>((accumulated: ProfileNameAndId[], node) => {
    const current = {
      id: node.data?.actions?.id ?? 0,
      name: node.data?.actions?.name ?? "",
      isPaymentBeneficiary: node.data?.actions?.isPaymentBeneficiary ?? false,
    };

    const children = getDescendants(node.childrenAfterGroup);
    return [...accumulated, current, ...children];
  }, []);
};

export const buildRelationshipTypes = (values: {
  isOwner?: boolean;
  isController?: boolean;
}): ProfileRelationshipEnum[] => {
  const roleArray: ProfileRelationshipEnum[] = [];
  if (values.isOwner) {
    roleArray.push(ProfileRelationshipEnum.Owner);
  }
  if (values.isController) {
    roleArray.push(ProfileRelationshipEnum.Controller);
  }
  return roleArray;
};
